var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-16"},[_c('SectionOrder',{attrs:{"product":_vm.product,"package-items":_vm.packageItems,"package-editions":_vm.packageEditions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }